<template>
  <div class="row justify-center align-center">
    <va-card class="flex xs12 sm12 md6 lg4 xl4">
      <va-card-content>
        <monta-form :form="form" @complete="(data)=>changePass(data, this)"/>
      </va-card-content>
    </va-card>
  </div>
</template>

<script>
import MontaForm from "@/components/monta-form/MontaForm";
import FormStruct from "@/pages/painel/usuarios/senha/MudarSenhaFormStruct";
import {changePass} from "./MudarSenhaFunctions"

export default {
  name: "MudarSenha",
  components: {MontaForm},
  props:['id'],
  data() {
    return {
      form: {
        struct: FormStruct
      },
      idUser: this.$route.params.id
    }
  },
  methods:{
    changePass
  }
}
</script>

<style scoped>

</style>